import { Kind } from "graphql";
import { ROOT_QUERY_INCLUDE_VARIABLE_NAME } from "./constants";
export function isRootQueryIncludeVariable(variableNode) {
    return variableNode.name.value.endsWith(ROOT_QUERY_INCLUDE_VARIABLE_NAME);
}
export function isRootLevelIncludeDirective(directive) {
    if (directive.name.value !== 'include') {
        return false;
    }
    if (typeof directive.arguments === 'undefined') {
        return false;
    }
    return directive.arguments.some((arg)=>arg.name.value === 'if' && arg.value.kind === Kind.VARIABLE && isRootQueryIncludeVariable(arg.value));
}

//# sourceMappingURL=rootQueryInclude.js.map